<app-page-interview-component
    [page]="page$ | async"
    [stepStart]="stepStart$ | async"
    [stepEnd]="stepEnd$ | async"
    [interviewee]="interviewee"
    (next)="onNext()"
    (previous)="onPrevious()"
>
    <ng-container page-interview-header *ngIf="config?.headerTemplate">
        <div uiTemplateLoader [template]="config.headerTemplate"></div>
    </ng-container>
</app-page-interview-component>
